import ConfigCrmApi from '../configs/ConfigCrmApi';
import Cookies from 'js-cookie';

// the current employee (name, email, photo for the top bar): the monolith's
// schedule/default-info payload, served by crm-api from the users service
const getAdmin = () =>
  ConfigCrmApi.get('users/current/default-info', {
    headers: { Authorization: Cookies.get('adminToken') },
  });

export default {
  getAdmin,
};
